import { render, staticRenderFns } from "./InstructorTable.vue?vue&type=template&id=acfc219e&scoped=true"
import script from "./InstructorTable.vue?vue&type=script&lang=js"
export * from "./InstructorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfc219e",
  null
  
)

export default component.exports